const NewMessageIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 14.3334V12M12 12V9.66668M12 12H9.66667M12 12H14.3333M12.0001 19C10.7283 19 9.5358 18.6609 8.50798 18.0681C8.40643 18.0095 8.35559 17.9803 8.30783 17.967C8.26338 17.9548 8.22369 17.9506 8.17768 17.9538C8.12864 17.9571 8.0779 17.974 7.97702 18.0077L6.18072 18.6064L6.1793 18.6071C5.80027 18.7334 5.6104 18.7967 5.48421 18.7517C5.37426 18.7125 5.28762 18.6257 5.24841 18.5158C5.20344 18.3897 5.26653 18.2004 5.39269 17.8219L5.39345 17.8196L5.99142 16.0256L5.99284 16.0219C6.02617 15.9219 6.04304 15.8713 6.04638 15.8225C6.04953 15.7764 6.04534 15.7365 6.03305 15.692C6.02002 15.6449 5.99126 15.595 5.93422 15.4961L5.93193 15.4922C5.33915 14.4643 5 13.2718 5 12C5 8.13402 8.13401 5 12 5C15.866 5 19 8.13402 19 12C19 15.866 15.8661 19 12.0001 19Z"
      stroke="#447AED"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NewMessageIcon;
